export default "__VITE_ASSET__zPvmFAkK__"